(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/views/pages/fractiongames-page.js') >= 0) return;  svs.modules.push('/modules/lotto/views/pages/fractiongames-page.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.lotto=_svs.lotto||{};
_svs.lotto.templates=_svs.lotto.templates||{};
svs.lotto.templates.fractiongames_page = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div id=\"ngFractiongamesRegion\" class=\"lotto-fractiongames-wrapper\"></div>\n";
},"useData":true});
Handlebars.partials['svs-lotto-fractiongames_page'] = svs.lotto.templates.fractiongames_page;
})(svs, Handlebars);


 })(window);